import { render, staticRenderFns } from "./ConsultaPreFaturaReceitaDetalhes.vue?vue&type=template&id=71935513"
import script from "./ConsultaPreFaturaReceitaDetalhes.vue?vue&type=script&lang=js"
export * from "./ConsultaPreFaturaReceitaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports